module.exports = __webpack_public_path__ + "img/3.c716b8c0.png";